export const getAvatarCharacterFrom = (text) => {
  if (text === undefined || text === null || text === "") {
    throw new Error("A Null or Empty text value was passed, unable to return the Avatar character");
  }

  return text[0].toUpperCase();
};
